import { createFileRoute } from '@tanstack/react-router';
import ResourcesContent from '@pages/Resources/components/ResourcesContent';

export const Route = createFileRoute('/home/$resource')({
  component: ResourcesContent,
});
